import { render, staticRenderFns } from "./ShopCarImagesField.vue?vue&type=template&id=35704add&scoped=true"
import script from "./ShopCarImagesField.vue?vue&type=script&lang=ts"
export * from "./ShopCarImagesField.vue?vue&type=script&lang=ts"
import style0 from "./ShopCarImagesField.vue?vue&type=style&index=0&id=35704add&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35704add",
  null
  
)

export default component.exports